import b from 'b_';
import cx from 'classnames';
import { Close as IconClose } from 'education-icons';
import { Button, Link, SimpleText, Text, SimpleCallback } from 'platform-components';
import React from 'react';

import { NOTIFICATION_TYPE, NOTIFICATION_THEME } from 'common.components/changes-notification/typings';

import './changes-notification__with-header.scss';

interface LinkProps {
    isRouter?: boolean;
    target?: '_blank';
    to: string;
}

interface Props {
    buttonTextId: string;
    linkProps: LinkProps;
    headerTextId: string;
    headerTextValues?: Record<string, any>;
    messageTextId: string;
    messageTextValues?: Record<string, any>;
    mix?: string;
    onClose: SimpleCallback;
    onAction?: SimpleCallback;
    icon?: React.ReactElement;
    theme: NOTIFICATION_THEME;
}

const NotificationWithHeader = (props: Props) => {
    const {
        buttonTextId,
        linkProps,
        icon,
        messageTextId,
        messageTextValues,
        headerTextId,
        headerTextValues,
        onClose,
        onAction,
        mix,
        theme,
    } = props;

    const iconClassName = icon?.props.className ? [icon?.props.className] : [];

    return (
        <div
            className={cx(
                mix,
                b('changes-notification', {
                    type: NOTIFICATION_TYPE.WITH_HEADER,
                    theme,
                })
            )}
        >
            <div className="changes-notification__content">
                <div className={b('changes-notification', 'header', { 'with-icon': Boolean(icon) })}>
                    {icon
                        ? React.cloneElement(icon, {
                              className: iconClassName.concat('changes-notification__icon').join(' '),
                          })
                        : null}
                    <Text
                        id={headerTextId}
                        size={Text.SIZE.XL}
                        type={Text.TYPE.MARKDOWN}
                        values={headerTextValues}
                        weight={Text.WEIGHT.M}
                    />
                </div>
                <div className={b('changes-notification', 'message', { 'with-icon': Boolean(icon) })}>
                    <Text id={messageTextId} type={Text.TYPE.MARKDOWN} values={messageTextValues} />
                </div>
            </div>
            <div className="changes-notification__controls">
                <Link {...linkProps}>
                    <Button
                        className="changes-notification__button"
                        onClick={onAction}
                        transparencyTheme={Button.TRANSPARENCY_THEME.DARK}
                        view={Button.VIEW.PSEUDO}
                    >
                        <SimpleText id={buttonTextId} />
                    </Button>
                </Link>
                <IconClose className="changes-notification__icon-close" onClick={onClose} />
            </div>
        </div>
    );
};

export default NotificationWithHeader;
